import React from 'react'
import Map from '../Map/map';
import Directions from '../Map/directions';
import {connect} from "react-redux";
import { CustomMarker } from '../Map/bmarker';

const OrdersMap = ({pickup, drop}) => (
    <Map>
        {pickup && <CustomMarker position={pickup} type={"P"}/>}
        {drop && <CustomMarker position={drop} type={"D"}/>}
        {pickup && drop && <Directions P={pickup} D={drop} />}
    </Map>
)

const mapStateToProps = ({orderdirection}) => ({
    pickup: orderdirection.pickup,
    drop: orderdirection.drop
})

export default connect(mapStateToProps)(OrdersMap)
